var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import 'whatwg-fetch';
import { requestRemoteConfig } from './requests/remote-config';
import { attributionRequest } from './requests/attribution';
import { BUFFER_CONFIG, DEFAULT_REMOTE_CONFIG, EVENTS_BUFFER_STORAGE_KEY, FEATURE_FLAGS, REMOTE_CONFIG_KEY, SESSION_INVALIDATE_TIMEOUT, } from './constants';
import { formatEventTime, millisecondsToSeconds, generateRandomId, splitArrayToChunks, formatEventVersion, validateEventsFromStorage, } from './utils';
import { sendEventsRequest } from './requests/send-events';
var PTIME_KEY = '[saykit] ptime';
var debug = {
    log: console.log,
    error: console.error, // @TODO: (?) send debug info to saykit
};
var SayKitWeb = /** @class */ (function () {
    function SayKitWeb() {
        this.backgroundTime = 0;
        this.backgroundTimeStartedAt = 0;
        this.session = null;
        this.eventNumberInSession = 1;
        this.buffer = [];
        this.eventsQueue = [];
        this.config = null;
        this.level = undefined;
        this.ptime = 0;
        this.remoteConfig = null;
        this.initialized = false;
        this.featureFlags = FEATURE_FLAGS;
    }
    SayKitWeb.prototype.getRemoteConfig = function (_a, onError) {
        var appKey = _a.appKey, version = _a.version, deviceId = _a.deviceId, _b = _a.storage, storage = _b === void 0 ? localStorage : _b;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_c) {
                this.config = { appKey: appKey, version: version, deviceId: deviceId, storage: storage };
                return [2 /*return*/, requestRemoteConfig({ appKey: appKey, version: version, deviceId: deviceId })
                        .then(function (config) {
                        _this.remoteConfig = config;
                        storage.setItem(REMOTE_CONFIG_KEY, JSON.stringify(config));
                        _this.featureFlags = config.game_settings;
                        return config;
                    })
                        .catch(function (error) {
                        onError === null || onError === void 0 ? void 0 : onError(error);
                        debug.error('An error occured while loading the remote config: ', error);
                        debug.log('Restoring config...');
                        var config = storage.getItem(REMOTE_CONFIG_KEY);
                        if (!config) {
                            _this.remoteConfig = DEFAULT_REMOTE_CONFIG;
                            return _this.remoteConfig;
                        }
                        try {
                            var parsed = JSON.parse(config);
                            _this.remoteConfig = parsed || DEFAULT_REMOTE_CONFIG;
                            return _this.remoteConfig;
                        }
                        catch (parsingError) {
                            _this.remoteConfig = DEFAULT_REMOTE_CONFIG;
                            return _this.remoteConfig;
                        }
                    })];
            });
        });
    };
    SayKitWeb.prototype.initialize = function (level) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var storedTotalPTime;
            return __generator(this, function (_b) {
                if (!this.remoteConfig || !this.config) {
                    throw new Error('Saykit cannot be initialized before calling getRemoteConfig');
                }
                this.level = level;
                this.listenDocumentVisibility();
                this.restoreEventsFromStorage();
                if (this.eventsQueue.length) {
                    this.sendEventsQueue();
                }
                if (BUFFER_CONFIG.eventsBufferEnabled) {
                    this.startEventBuffer();
                }
                storedTotalPTime = (_a = this.config.storage) === null || _a === void 0 ? void 0 : _a.getItem(PTIME_KEY);
                if (!isNaN(Number(storedTotalPTime))) {
                    this.ptime = Number(storedTotalPTime);
                }
                this.initialized = true;
                debug.log('SayKitWeb initialized successfully!');
                return [2 /*return*/];
            });
        });
    };
    SayKitWeb.prototype.trackEvent = function (name, params) {
        var partialEvent = __assign(__assign({}, this.buildBaseEvent(name)), params);
        if (this.config === null || this.level === undefined || this.remoteConfig === null) {
            this.eventsQueue.push(partialEvent);
        }
        else {
            this.sendEvent(__assign(__assign({}, partialEvent), { device_id: this.config.deviceId, version: formatEventVersion(this.config.version, this.remoteConfig.runtime.segment), level: this.level }));
        }
    };
    SayKitWeb.prototype.startBackgroundTime = function () {
        this.backgroundTimeStartedAt = Date.now();
    };
    SayKitWeb.prototype.finishBackgroundTime = function () {
        if (!this.backgroundTimeStartedAt) {
            return;
        }
        var finishedAt = Date.now();
        this.backgroundTime += finishedAt - this.backgroundTimeStartedAt;
        this.backgroundTimeStartedAt = 0;
    };
    SayKitWeb.prototype.update = function (options) {
        if (this.config && options.deviceId) {
            this.config.deviceId = options.deviceId;
        }
        if (options.level) {
            this.level = options.level;
        }
    };
    /**
     * There are special events which server sends (e.g. payments)
     * Server can't generate a lot of fields, such as session, playing time and so on
     * Therefore we have to prepare event object on client side and pass it to server
     * @param event - event name
     * @returns event object
     */
    SayKitWeb.prototype.getPayloadForServerEvent = function (event) {
        if (this.config === null || this.level === undefined || this.remoteConfig === null) {
            throw new Error('Saykit is not initialized yet');
        }
        return __assign(__assign({}, this.buildBaseEvent(event)), { device_id: this.config.deviceId, version: formatEventVersion(this.config.version, this.remoteConfig.runtime.segment), level: this.level, app_key: this.config.appKey, country: this.remoteConfig.runtime.country });
    };
    SayKitWeb.prototype.getUTMParameters = function () {
        var searchParams = window.location.search;
        var queries = searchParams.replace('?', '').split('&');
        var attributes = queries.filter(function (param) { return /^(utm_|gclid)/.test(param); }).join('&');
        return attributes;
    };
    SayKitWeb.prototype.trackUTMParameters = function () {
        if (!this.config) {
            throw new Error('Params cannot be tracked before calling getRemoteConfig');
        }
        var attributes = this.getUTMParameters();
        if (attributes.length > 0) {
            return attributionRequest({
                appKey: this.config.appKey,
                deviceId: this.config.deviceId,
                attributes: attributes,
            })
                .then(function () { return attributes; })
                .catch(function () {
                throw { code: 'FETCH_FAILED', attributes: attributes };
            });
        }
        return Promise.reject({ code: 'NO_ATTRS' });
    };
    SayKitWeb.prototype.getBackgroundTime = function () {
        return this.backgroundTime;
    };
    SayKitWeb.prototype.buildBaseEvent = function (event) {
        return {
            time: formatEventTime(new Date()),
            session: this.getSession(),
            sequence: this.eventNumberInSession++,
            device_os: navigator.userAgent,
            ptime: millisecondsToSeconds(this.ptime + performance.now() - this.backgroundTime),
            event: event,
        };
    };
    SayKitWeb.prototype.sendEvent = function (event) {
        var _a, _b;
        if (BUFFER_CONFIG.eventsBufferEnabled) {
            this.buffer.push(event);
            if (this.buffer.length >= BUFFER_CONFIG.eventsBufferSize) {
                sendEventsRequest({ appKey: this.config.appKey, events: this.buffer });
                this.buffer = [];
            }
            (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.storage) === null || _b === void 0 ? void 0 : _b.setItem(EVENTS_BUFFER_STORAGE_KEY, JSON.stringify(this.buffer));
        }
        else {
            sendEventsRequest({ appKey: this.config.appKey, events: [event] });
        }
    };
    SayKitWeb.prototype.sendEventsQueue = function () {
        var _this = this;
        // if we are here we have events which has been added while there were no remote config
        // we have to append missing fields now and send it
        var events = this.eventsQueue.map(function (event) { return (__assign(__assign({}, event), { version: formatEventVersion(_this.config.version, _this.remoteConfig.runtime.segment), device_id: _this.config.deviceId, level: _this.level })); });
        if (BUFFER_CONFIG.eventsBufferEnabled) {
            var eventChunks = splitArrayToChunks(events, BUFFER_CONFIG.eventsBufferSize);
            eventChunks.forEach(function (chunk) {
                var _a, _b;
                if (chunk.length === BUFFER_CONFIG.eventsBufferSize) {
                    sendEventsRequest({ appKey: _this.config.appKey, events: chunk });
                }
                else {
                    _this.buffer = __spreadArray(__spreadArray([], __read(_this.buffer), false), __read(chunk), false);
                    (_b = (_a = _this.config) === null || _a === void 0 ? void 0 : _a.storage) === null || _b === void 0 ? void 0 : _b.setItem(EVENTS_BUFFER_STORAGE_KEY, JSON.stringify(_this.buffer));
                }
            });
        }
        else {
            sendEventsRequest({ appKey: this.config.appKey, events: events });
        }
    };
    SayKitWeb.prototype.restoreEventsFromStorage = function () {
        var _a, _b;
        var eventsFromStorage = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.storage) === null || _b === void 0 ? void 0 : _b.getItem(EVENTS_BUFFER_STORAGE_KEY);
        if (eventsFromStorage) {
            var events = JSON.parse(eventsFromStorage);
            this.buffer = validateEventsFromStorage(events);
        }
    };
    SayKitWeb.prototype.sendAllBuffer = function () {
        var _a, _b;
        if (this.buffer.length > 0) {
            sendEventsRequest({ appKey: this.config.appKey, events: this.buffer });
            this.buffer = [];
            (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.storage) === null || _b === void 0 ? void 0 : _b.setItem(EVENTS_BUFFER_STORAGE_KEY, JSON.stringify([]));
        }
    };
    SayKitWeb.prototype.startEventBuffer = function () {
        var _this = this;
        setInterval(function () {
            if (_this.buffer.length > 0) {
                _this.sendAllBuffer();
            }
        }, BUFFER_CONFIG.eventsBufferTimeout);
    };
    SayKitWeb.prototype.getSession = function () {
        if (!this.session) {
            this.session = generateRandomId();
            debug.log('New session id was generated: ', this.session);
        }
        return this.session;
    };
    SayKitWeb.prototype.listenDocumentVisibility = function () {
        var _this = this;
        document.addEventListener('visibilitychange', function () {
            var _a, _b;
            if (document.visibilityState === 'hidden') {
                _this.sendAllBuffer();
                (_b = (_a = _this.config) === null || _a === void 0 ? void 0 : _a.storage) === null || _b === void 0 ? void 0 : _b.setItem(PTIME_KEY, String(_this.ptime + performance.now() - _this.backgroundTime));
                _this.startBackgroundTime();
            }
            if (document.visibilityState === 'visible') {
                var startedAt = _this.backgroundTimeStartedAt;
                var finishedAt = Date.now();
                if (startedAt && finishedAt - startedAt > SESSION_INVALIDATE_TIMEOUT) {
                    _this.session = null;
                    _this.eventNumberInSession = 1;
                    debug.log("User was inactive more than ".concat(SESSION_INVALIDATE_TIMEOUT, "ms. Dropping session..."));
                }
                _this.finishBackgroundTime();
            }
        });
        document.addEventListener('pagehide', function () {
            _this.sendAllBuffer();
        });
    };
    return SayKitWeb;
}());
export default new SayKitWeb();
//# sourceMappingURL=index.js.map